import { Injectable } from '@angular/core';

import { AccessTokenClaims, AUTH_TOKEN_STORAGE_KEY } from '../models';
import { decodeAccessToken } from '../utils';

@Injectable({
  providedIn: 'root',
})
export class AuthStoreService {
  private token: string | null = localStorage.getItem(AUTH_TOKEN_STORAGE_KEY);

  public getToken(): string | null {
    return this.token;
  }

  public getClaims(): AccessTokenClaims | null {
    return this.token ? decodeAccessToken(this.token) : null;
  }

  public setToken(token: string): void {
    localStorage.setItem(AUTH_TOKEN_STORAGE_KEY, token);
    this.token = token;
  }

  public resetStore(): void {
    localStorage.removeItem(AUTH_TOKEN_STORAGE_KEY);
    this.token = null;
  }
}
